import React from "react";

const codeStyle = {
  background: "#1e1e1e",
  color: "#d4d4d4",
  padding: "15px",
  borderRadius: "10px",
  overflowX: "auto",
  fontSize: "14px",
  marginBottom: "20px",
  border: "1px solid #333"
};
// const codeStyle = {
//     background: "#f1f1f1",
//     border: "1px solid #ddd",
//     padding: "12px",
//     borderRadius: "6px",
//     fontFamily: "monospace",
//     fontSize: "14px",
//     color: "#333",
//     marginTop: "10px",
//     marginBottom: "10px"
//   };

const labelStyle = {
  background: "#198754",
  color: "white",
  padding: "6px 12px",
  borderRadius: "6px",
  display: "inline-block",
  marginBottom: "10px",
  fontSize: "13px",
  fontWeight: "bold"
};

function Pi3Bluetooth() {
  return (
    <div style={{ padding: "20px", lineHeight: "1.6" }}>

      <h1>Using Raspberry Pi 3 On-Board Bluetooth for Communication</h1>

      <h1>Introduction</h1>

      <ul>
        <li>
        Raspberry Pi 3 has come up with a great on-board feature i.e. the on-board Bluetooth. So, there is no need to for external Bluetooth dongle. This frees up a USB port for other uses, which would otherwise be used up by the Bluetooth dongle.
        </li>
        <li>
        Raspberry Pi 3 has BCM43438 highly integrated single chip which includes 2.4GHz WLAN, Bluetooth and FM receiver.
        </li>
      </ul>

      <p>
      Before start communicating using Raspberry Pi’s On-board Bluetooth, we need to set up the On-board Bluetooth of Raspberry Pi.
      </p>

      <h1>How to set up the On-board Bluetooth of Raspberry Pi</h1>

      <p>
      Raspberry Pi has on-board Bluetooth which can be used for communication or sending/receiving files.

     </p><p>Before establishing communication between Raspberry Pi and a Bluetooth enabled device, we need to pair them.

     </p> <p> Pairing a Bluetooth device on Raspberry Pi is same as that on a mobile or Laptop.
      </p>

      <p>Turn-ON Bluetooth as follows,</p>

      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/341/description/turn_on_bluetooth.png"
        alt="Turn On Bluetooth"
        style={{ maxWidth: "100%", borderRadius: "10px" }}
      />

      <p>Make it discoverable:</p>

      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/341/description/make_discoverable.png"
        alt="Discoverable"
        style={{ maxWidth: "100%", borderRadius: "10px" }}
      />

      <p>Now, select option Add Device…</p>

      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/341/description/add_device.png"
        alt="Add Device"
        style={{ maxWidth: "100%" }}
      />

      <p>After selecting Add device… pop-up window appear which will be as follows,</p>

      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/341/description/Device_list.png"
        alt="Device List"
        style={{ maxWidth: "100%" }}
      />

      <p>
      In above window, we can see mobile Bluetooth device named “ZUK Z1”. Select device and then click on pair. This will prompts for pairing, and displays the pin (the pin that was randomly generated by raspberry pi) from Raspberry Pi to Bluetooth device, which should cause the device to ask you to confirm the connection.

</p> <p>After the device accepts the connection by using the pair option, our raspberry pi and the Bluetooth device will be paired and connection can be established between them. Now our Raspberry Pi is ready to communicate with the paired device.
      </p>

      <h1>How to transfer files between Raspberry Pi and a device via Bluetooth?</h1>
      <p>There are two ways for communicating between Raspberry Pi and a device via Bluetooth.</p>
      <ul> 
        <li>Bluetooth GUI (Graphical User Interface)</li>
        <li>Command Line Interface (CLI)</li>
      </ul>
      <p>Before using GUI or CLI for accessing Bluetooth based transfer, we need to install the following packages,

      </p>
      <p><b>Blueman </b>–It is a full featured Bluetooth manager. It provides GUI based setting panel Bluetooth manager.

     </p><p><b>Bluez</b> –This package provides the Bluetooth protocol stack and the bluetoothctl utility.

     </p><p><b> Bluetooth </b>–This package provides all the plugins supported by BluezBluetooth stack.</p>
      <p>Now to use Bluetooth service install above packages using following command,</p>

      {/* <div style={labelStyle}>Command</div> */}
      <pre style={codeStyle}>
{`sudo apt-get install blueman bluez bluetooth`}
      </pre>

      <p>After successful installation of above packages, reboot Raspberry Pi.</p>

      <p><b>Using Graphical User Interface(GUI) for Bluetooth Services</b></p>

      <p>
      Raspberry Pi don’t have GUI for accessing Bluetooth services like in laptop/mobile. To get GUI for Bluetooth, we installed packages mentioned above.

</p><p>Now, we can access Bluetooth services (send/receive) using GUI. For this, go to the menu and select preferences. In preferences, select Bluetooth Manager. Now, we can see Bluetooth manager window with all the visible Bluetooth devices listed as shown below.
      </p>

      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/341/description/Bluetooth%20Manager.png"
        alt="Bluetooth Manager"
        style={{ maxWidth: "100%" }}
      />

      <p>We need to make Bluetooth visible so that it is discoverable to other devices. To do this, select Adapter à preferences as shown below,</p>

      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/341/description/adapter_preferences.png"
        alt="Adapter Settings"
        style={{ maxWidth: "100%" }}
      />

      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/341/description/Screenshot_9.png"
        alt="Settings"
        style={{ maxWidth: "100%" }}
      />

      <p>We can transfer files from Raspberry Pi to selected Bluetooth device.For sending file, right click on selected device and select send a file as shown below,</p>

      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/341/description/send_file_through_bluetooth.png"
        alt="Send File"
        style={{ maxWidth: "100%" }}
      />
     <p>Browse a file and send it. We can receive a file too on Raspberry Pi.</p>
      <p><b>Command Line Interface (CLI) for Bluetooth Services</b></p>
        <p>The packages which we have installed earlier are also necessary for command line interface.

        </p><p> Pairing a Bluetooth device from shell is the simplest and most reliable option.</p>
      <p><b>Bluetooth Connection using bluetoothctl</b></p>
      <p>Follow the steps given below to pair and connect Raspberry Pi’s Bluetooth with another Bluetooth device. We are using bluetoothctl utility for pairing and establishing connection between Raspberry Pi and Bluetooth devices.</p>
      <p>Enter following command to start bluetoothctl</p>
<div
  style={codeStyle}
>
  bluetoothctl
</div>
<p>turn the power to the controller on using following command</p>

<div
  style={codeStyle}
>
power on
</div>

<p>enter devices to get the mac address of device with which we want to pair. This command gives a list of available devices.</p>

<div
  style={codeStyle}
>
devices
</div>
<p>if no device is in the list then search for devices as follows,</p>

<div
  style={codeStyle}
>
scan on
</div>
<p>turn the agent on</p>

<div
  style={codeStyle}
>
agent on
</div>
<p>pair the Bluetooth device</p>
<div
  style={codeStyle}
>
{"pair <mac address>"}
</div>
<p>Example:</p>

      <pre style={codeStyle}>
{`pair 01:02:03:04:05:06`}
      </pre>

<p>If using a device without PIN then we need to manually mark the device as a trust device as follows,</p>
<div
  style={codeStyle}
>
{"trust <mac address>"}
</div>
<p>Finally establish a connection between two Bluetooth enabled devices.</p>
<div
  style={codeStyle}
>
{"Connect <mac address>"}
</div>
<p>To know more about commands, you can enter help command.</p>

      <p><b>Send/Receive Data over Bluetooth using CLI</b></p>

      <p>We can send/receive data from/on Raspberry Pi over Bluetooth using CLI. This communication is helpful when we need to control any device connected to Raspberry Pi using smartphone/laptop over Bluetooth. For such applications CLI is the most efficient way of communication. Here, we are using RFCOMM (Radio Frequency Communication) Bluetooth protocol.</p>

      
      <h2>Example</h2>

<p>
Let’s exchange data between Smartphone (Mobile) and Raspberry Pi using CLI over Bluetooth.
</p>

<p>
To use CLI for communicating between two Bluetooth devices follow the steps given below,
</p>

<p>
We already paired a device using bluetoothctl.
</p>

<p>
Here, we are using hciconfig for configuring Bluetooth devices to establish data transfer between them.
</p>

<p>
Enter following command for Raspberry Pi Bluetooth device information.
</p>

<div style={codeStyle}>hciconfig</div>

<p>
This will provide mac address of Raspberry Pi’s Bluetooth. Also, it gives information about whether the port is UP/DOWN.
</p>

<p>
If it is DOWN, then enter following command to make it UP.
</p>

<div style={codeStyle}>hciconfig hci0 up</div>

<p>
<b>Note:</b> sometimes it gives an error like “operation not possible due to RF-Kill” then it can be resolved with
</p>

<div style={codeStyle}>rfkill unblock all</div>

<p>
create Bluetooth profile as follows
</p>

<div style={codeStyle}>sdptool add sp</div>

<p>
To receive data from smartphone, we should connect Smartphone to Raspberry Pi. For connecting Smartphone and communicating (send/receive) data, we need to use a Bluetooth application on Smartphone. Here, we are using Blueterm application.
</p>

<p>
For establishing connection between Raspberry Pi and Smartphone via Bluetooth, use following command
</p>

<div style={codeStyle}>{"sudo rfcomm listen hci0&"}</div>

<p>
This command make the Raspberry Pi wait for device(smartphone) request to connect.
</p>

<p>
We have to open Blueterm application and select Bluetooth device (Raspberry Pi) with which we want to connect.
</p>

<p>
When device is connected successfully, we can receive messages from Smartphone.
</p>

<p>
Now, we can send character/messages from Smartphone to Raspberry Pi but we can’t see them on Raspberry Pi terminal. To see received character/messages, enter following command
</p>

<div style={codeStyle}>cat /dev/rfcomm0</div>

<p>
Now we can see the messages in terminal which is receiving.
</p>

<p>
If we want to send messages from Raspberry Pi to Smartphone over Bluetooth then use following command,
</p>

<div style={codeStyle}>
  {"echo “type character/message here” >/dev/rfcomm0"}
</div>

<p>
Now, we can successfully communicate messages between Raspberry Pi and Mobile over Bluetooth. This message transferring can be used to build Raspberry Pi based applications like controlling home appliances (heater, Light, door, fan) using mobile phone over Bluetooth. Just by sending message from mobile we can control the devices connected to Raspberry Pi.
</p>

    </div>
  );
}

export default Pi3Bluetooth;